module.exports = __webpack_public_path__ + "static/kobold_inventor-ad013d65aeb8aa9a7dae45d3913d1507.jpeg";